import Marquee from "react-fast-marquee";

const ITEMS = [
  "$LA28",
  "LA28 ARMY",
  "COUNTDOWN TO 2028",
  "INTERNET CULTURE",
  "DEGEN ENERGY",
  "MEME MOVEMENT",
];

export default function TickerStrip() {
  return (
    <div
      data-testid="ticker-strip"
      className="py-6 border-y border-white/10 bg-[#0A0A10]"
    >
      <Marquee speed={60} gradient={false}>
        {[...Array(3)].map((_, group) =>
          ITEMS.map((it, i) => (
            <div
              key={`${group}-${i}`}
              className="flex items-center gap-10 px-6 font-heading text-3xl sm:text-4xl font-black tracking-tight"
            >
              <span className="text-white">{it}</span>
              <span className="text-[#00F0FF]">✦</span>
            </div>
          )),
        )}
      </Marquee>
    </div>
  );
}
